import { createFooterMapper } from 'modules/campaigns/modules/campaigns-reports/utils/normalizeColumnDefs';
import * as FIELDS from '../../fields';
import { HIERARCHY_CAMPAIGN_REPORT_ID } from './hierarchyCampaignReportId';

const emptyColumns = [FIELDS.ID, FIELDS.NAME].map(createFooterMapper(HIERARCHY_CAMPAIGN_REPORT_ID));

export const hierarchyCampaignReportFooterColumnDefinition = [...emptyColumns];
